import Gooey, { Component } from '@srhazi/gooey';
import './ui-component.css';
export const UiComponent: Component<{
    name: string;
    description: string;
    children?: JSX.Node | JSX.Node[];
}> = ({ name, description, children }) => {
    return (
        <div class="ui-component">
            <h2 class="ui-component__name">{name}</h2>
            <div class="ui-component__description">{description}</div>
            <div class="ui-component__body">{children}</div>
        </div>
    );
};
